// Removes every leading and trailing occurrence of `char` (a single character) from `value`.
export const trimChar = (value: string, char: string): string => {
  let start = 0;
  let end = value.length;

  while (start < end && value[start] === char) start++;
  while (end > start && value[end - 1] === char) end--;

  return value.slice(start, end);
};
